// Shared helpers used across the Equipment* family of components.

export function reliability_badge_class(score: number): string {
  if (score >= 90) return "bg-success-subtle text-success-subtle-foreground";
  if (score >= 70)
    return "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400";
  if (score >= 50)
    return "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400";
  return "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400";
}
